const TARIFF_BUNDLE_YEARLY = {
  title: "AMZScout Bundle",
  period: "Period Yearly",
  offer: {
    icon: "MOST POPULAR",
    name: "YEARLY",
    price: 399,
    cents: 99,
  },
  subTitle: {
    text: "+ Free 1-on-1 Mentor Call",
    tooltip: "Get personal guidance during a 30-minute call from proven Amazon six- or seven-figure sellers. Discuss your plan for launch your own business on Amazon or strategize changes for your existing business."
  },
  tariff: {
    base: {
      pay: {
        price: 33,
        cents: 39,
        period: "Period Monthly",
      },
      billed: {
        price: 399,
        cents: 99,
      },
      buyNowPath: "/checkout/?bundle=bundle-ai-yearly",
    },
    PL: {
      pay: {
        discount: {
          price: 1107,
          cents: 99,
        },
        price: 41,
        cents: 69,
        period: "Period Monthly",
      },
      billed: {
        price: 499,
        cents: 98,
      },
      save: 600,
      buyNowPath: "/checkout/?bundle=bundle-ai-pl-yearly",
    },
    R: {
      pay: {
        discount: {
          price: 1107,
          cents: 99,
        },
        price: 41,
        cents: 69,
        period: "Period Monthly",
      },
      billed: {
        price: 499,
        cents: 98,
      },
      save: 600,
      buyNowPath: "/checkout/?bundle=bundle-ai-oa-yearly",
    },
    PL_R: {
      pay: {
        discount: {
          price: 1815,
          cents: 99,
        },
        price: 49,
        cents: 99,
        period: "Period Monthly",
      },
      billed: {
        price: 599,
        cents: 97,
      },
      save: 1200,
      buyNowPath: "/checkout/?bundle=bundle-ai-pl-oa-yearly",
    },
  },
};

export default TARIFF_BUNDLE_YEARLY;
